module.exports = __webpack_public_path__ + "img/icon_link.72cc0a2b.svg";